import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';

import { DATATABLE_CONFIG, WORK_PERMIT_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

class CertificateMaster extends Component {
    state = {
        display : true,
        selectedItems:[]
    }

   

    actionTemplate = (rowData, column) => {
        //let rowIndex = column.rowIndex;
        return <div className="actionCenter">
            
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
            <Link to={"/Certificate-Master/edit/"+rowData.employeeDocumentID}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }

            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
            <Link to={"/Certificate-Master/view/"+rowData.employeeDocumentID}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
            
        </div>;
    }


  

    componentDidMount(){        
        this.props.getMasterTableList('GetWPCertificate'); 
        this.getAccess = HASACCESS(WORK_PERMIT_SUBMENU_ID);
    }

  
    render() { 
        
        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        let tableData = [];
        if(this.props.tableLists && this.props.tableLists.length > 0 ){
            tableData = this.props.tableLists.map(el => {
            return{ empDetails: el.employeeName +" - " + el.employeeNo, 
            docType: (el.docDocumentType == "Acceptor") ? "Acceptor" : "Safety Controller", 
            ...el}})

        }

    

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        return (
            <div className="p-grid padding">
               { this.props.loading && <div className="page-loader"></div>}
               { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
               { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
               {/* <Toast ref={(el) => this.growl = el} /> */}
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Certificate Master</h1>
               
                        <div className="p-grid">
                           

                            <div className="p-col-12  p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                <Link to="/Certificate-Master/add/new"><Button style={{float: 'right'}} label="Add Certificate Master" icon="pi pi-plus" className="ml1" /></Link>
                                }

                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!==false) &&
                                <Button onClick={this.delete} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }
                                
                                
                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                        
                        <DataTable value={tableData} selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                         globalFilter={this.state.globalFilter}  header={header} {...DATATABLE_CONFIG} >                                
                                <Column field="docDocumentNumber" header="Document Number" sortable={true} />
                                <Column field="empDetails" header="Employee Details" />
                                <Column field="docType" header="Document Type" />
                                <Column field="documentName" header="Document Name(s)" />
                                <Column field="docIssueDate" header="Document Issue Date" />
                                <Column field="docIssuePlace" header="Document Issue Place" />
                                <Column field="docExpiryDate" header="Document Expiry Date" />
                                <Column field="action" body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        employee: Employee,
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(CertificateMaster);